import type { ParameterCreateInput } from "@globals";
import type { ColumnMapping } from "@lib/dataset/Mapping/types";

export default function getExperimentParametersFromMapping(mappings: ColumnMapping[]): ParameterCreateInput[] {
  return mappings
    .filter(item => !item.disabled && item.type === "parameter")
    .map(item => ({
      id: item.id,
      name: item.column_name,
      is_batch_constrained: false,
      ...(item.isCategorical
        ? {
            categories: item.categories?.map((category: string) => ({ id: crypto.randomUUID(), name: category })) || [],
            type: "categorical"
          }
        : {
            lower_bound: item.lower_bound ?? 0,
            upper_bound: item.upper_bound ?? 0,
            step_size: item.step_size,
            type: "numerical"
          })
    }));
}
